<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M-3.67,782.5c1.38,0,2.5,1.12,2.5,2.5v10.01c1.05,0.79,1.67,2.02,1.67,3.33c0,2.3-1.87,4.17-4.17,4.17s-4.17-1.87-4.17-4.17
	c0-1.31,0.62-2.54,1.67-3.33V785C-6.17,783.62-5.05,782.5-3.67,782.5L-3.67,782.5z M2.17,788.33l6.67-1.67L3,790.83l4.17,1.67h-5
	l1.67,2.5l-3.33-1.67v-5.83l3.33-2.5L2.17,788.33z M-4.5,795.98c-1,0.35-1.67,1.3-1.67,2.35c0,1.38,1.12,2.5,2.5,2.5
	c1.38,0,2.5-1.12,2.5-2.5c0-1.06-0.67-2-1.67-2.35v-7.65H-4.5V795.98z"/>
</svg>

</template>